import { ContentWrapper } from "./styles";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import React, { useEffect } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import {
  Error,
  InputWrapper,
  ItemWrapper,
} from "../../../Wallet/ChinaPayoutV2/styles";
import { Input } from "../../../../../components/common/Input";
import { InputPhone } from "../../../../../components/common/InputPhone";
import { TextArea } from "../styles";
import { Button } from "../../../../../components/common/Button";
import { savedPayoutData } from "../../../redux/formDataSlice";
import { useParams } from "react-router-dom";
import { countryToISOCode } from "../../../const";

type Props = {
  handleNext?: () => void;
  handlePrevious?: () => void;
};

type BeneficiaryData = {
  beneficiaryName: string;
  beneficiaryPhoneNumber: string;
  description: string;
};

const Beneficiary = ({ handleNext, handlePrevious }: Props) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm<BeneficiaryData>();

  const getSavedData = useAppSelector((state) => state.formData.intPayoutData);
  const dispatch = useAppDispatch();

  const { country } = useParams();
  const defaultCountry = countryToISOCode[country?.toLowerCase()];

  useEffect(() => {
    if (getSavedData) {
      Object.keys(getSavedData).forEach((key) => {
        setValue(
          key as keyof BeneficiaryData,
          getSavedData[key as keyof BeneficiaryData],
        );
      });
    }
  }, [getSavedData, setValue]);

  const onSubmit: SubmitHandler<BeneficiaryData> = (data) => {
    dispatch(savedPayoutData(data));
    handleNext?.();
  };

  return (
    <ContentWrapper>
      <InputWrapper>
        <Controller
          name="beneficiaryName"
          control={control}
          rules={{ required: "Beneficiary name is required" }}
          render={({ field }) => (
            <Input
              value={field.value}
              label="Beneficiary name"
              onChange={field.onChange}
            />
          )}
        />
        {<Error>{errors?.beneficiaryName?.message}</Error>}
      </InputWrapper>

      <InputWrapper>
        <Controller
          name="beneficiaryPhoneNumber"
          control={control}
          rules={{ required: "Beneficiary phone number is required" }}
          render={({ field }) => (
            <InputPhone
              label="Phone number"
              placeholder="Enter phone number"
              field={field}
              defaultCountry={defaultCountry}
            />
          )}
        />
        {<Error>{errors?.beneficiaryPhoneNumber?.message}</Error>}
      </InputWrapper>

      <InputWrapper>
        <Controller
          name="description"
          control={control}
          rules={{ required: false,  maxLength: { value: 100, message: "Description cannot exceed 100 characters" }}}
          render={({ field }) => (
            <TextArea placeholder="Payment description" {...field} />
          )}
        />
        {<Error>{errors?.description?.message}</Error>}

      </InputWrapper>

      <ItemWrapper>
        <Button
          onClick={handlePrevious}
          label="Prev"
          height="48px"
          theme="alternate"
          width="203px"
        />

        <Button
          onClick={handleSubmit(onSubmit)}
          label="Continue"
          height="48px"
        />
      </ItemWrapper>
    </ContentWrapper>
  );
};

export default Beneficiary;
